import { Avatar } from "antd";
import { UserRound } from "lucide-react";

export const ColumnsUser = (title, field) => {
  const table = [
    {
      title: "Classificação",
      dataIndex: "rank",
      textWrap: "word-break",
      ellipsis: true,
      width: "15%",
      render: (rank) => <>{rank}º</>,
    },
    {
      title: "Foto",
      dataIndex: "img",
      width: "15%",
      render: (text, row) => {
        return (
          <Avatar src={row.img} icon={<UserRound size={50} />} size={50} />
        );
      },
    },
    {
      title: "Nome",
      dataIndex: "name",
      textWrap: "word-break",
      ellipsis: true,
      width: "15%",
    },
    {
      title: "Idade",
      dataIndex: "age",
      textWrap: "word-break",
      ellipsis: true,
      width: "15%",
      render: (text) => {
        return text + " anos";
      },
    },
    {
      title: title,
      dataIndex: field,
      textWrap: "word-break",
      ellipsis: true,
      width: "15%",
    },
  ];
  return table;
};
